var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ruleComponent"},[_c('div',{staticClass:"rule",on:{"click":function($event){_vm.$refs.popup.show = true}}},[_vm._v(" 活动规则 ")]),_c('PopupShow',{ref:"popup",attrs:{"popupType":"rule","activityRule":_vm.activityRule}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }